module.exports = "/assets/81a3030bd3c48559ae1366f8a5e755dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/NK.png
// module id = 2773
// module chunks = 0